// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="box">
  <sub-header header="'Recreate discount charges ledger'"></sub-header>

  <form-section>

    <div ng-if="!\$ctrl.forAccretionFeesConfigured" class="alert alert--danger">
      Loan product must have at least one fee for accretion configured.
    </div>

    <div class="alert">
      You will still need to perform manual GL tickets afterwards.
    </div>

    <div ng-if="\$ctrl.hasNewlyCalculatedFees()" class="alert">
      The highlighted item(s) are newly calculated fee(s) that are not included in the current discount charges ledger.
    </div>

    <form name="discountChargesLedgerForm">

      <validator condition="\$ctrl.forAccretionFeesConfigured"></validator>

      <table class="table table--generate-row-ids">
        <thead>
        <th></th>
        <th>Name</th>
        <th>Current amount</th>
        <th>Difference</th>
        <th>Overridden amount</th>
        </thead>

        <tbody>
        <tr ng-repeat="fee in \$ctrl.accretedFees"
            ng-class="{'new-fee-outline': fee.id === null}">
          <td></td>
          <td>{{ fee.feeName }}</td>
          <td>
            <cash value="fee.currentAmount"
                  ng-disabled="true"></cash>
          </td>
          <td>
            <cash value="\$ctrl.calculateDiff(fee)"
                  ng-disabled="true"></cash>
          </td>
          <td>
            <cash ng-model="fee.overrideAmount"
                  ng-required="true"
                  min="0">
            </cash>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Total</td>
          <td>
            <cash value="\$ctrl.calculateTotal('CURRENT')"
                  ng-disabled="true">
            </cash>
          </td>
          <td></td>
          <td>
            <cash value="\$ctrl.calculateTotal('OVERRIDDEN')"
                  ng-disabled="true">
            </cash>
          </td>
        </tr>
        </tbody>
      </table>

      <div ng-if="\$ctrl.simulatedDiscountChargesLedger">
        <discount-charges-ledger
          discount-charges="\$ctrl.simulatedDiscountChargesLedger">
        </discount-charges-ledger>
      </div>

      <div ng-if="\$ctrl.hasNoSimulatedLedger" class="alert alert--danger">
        Existing discount charges ledger will be removed without creating a new one.
      </div>

      <div class="buttons pull-right">
        <button type="button"
                class="btn btn-warning"
                ng-click="\$ctrl.redirectBack()">
          Cancel
        </button>
        <button type="button"
                class="btn btn-default"
                ng-disabled="discountChargesLedgerForm.\$invalid || !\$ctrl.canPerformSimulation()"
                ng-click="\$ctrl.simulateDiscountCharges()">
          Simulate
        </button>
        <button type="submit" class="btn btn-primary"
                ng-click="\$ctrl.save()"
                ng-disabled="discountChargesLedgerForm.\$invalid || !\$ctrl.canPerformSimulation()">
          Save
        </button>
      </div>

    </form>

  </form-section>

</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/recreate-discount-charges-ledger/recreate-discount-charges-ledger.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;